import ServiceBase from './ServiceBase';

export default class ProjectCatalogCategoriesService extends ServiceBase {
    getAdminProjectCatalogCategories() {
        return this.request('get', 'admin/projectCatalogCategories/getProjectCatalogCategories');
    }

    getProjectCatalogCategories() {
        return this.request('get', 'projectCatalogCategories/getProjectCatalogCategories');
    }
}
